import { Component, ViewChild } from '@angular/core';
import { TablesAgGridService } from './tables-ag-grid.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { NewConfirmModalService } from 'app/generic/new-confirm-modal/new-confirm-modal.service';
import { HookFunctions } from 'app/generic/hookFunctions';
import { MultiButtonRendererComponent } from 'app/generic/multi-button-renderer/multi-button-renderer.component';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-tables-ag-grid',
  templateUrl: './tables-ag-grid.component.html',
  styleUrls: ['./tables-ag-grid.component.scss'],
  providers: [TablesAgGridService]
})
export class TablesAgGridComponent {
  // MODAL
  @ViewChild('theModalDetailTravel') theModalDetailTravel: any;

  //FORM
  formSearch: FormGroup = this.fb.group({});

  // SETTINGS
  settingsTravels: any;
  settingsMyTravels: any;

  // VARIABLES
  travelDetail: any;
  isOnlyForDetail: boolean = true;
  cittaPartenzaFilter: string = "";
  cittaArrivoFilter: string = "";
  cittaPartenzaMineFilter: string = "";
  cittaArrivoMineFilter: string = "";

  // VAR EX
  actualPage: number = 1;
  gridOptions: any;
  gridServerOptions: any;
  myTravels: any = [];
  data = [
    {
      id: 13,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 3,
      autista: {
        nome: 'Federico',
        cognome: 'Trimarco',
        recensione: 4.5,
        img: '../../../../assets/IMG/foto-profilo-test.jpeg'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 12,
      cittaPartenza: 'Roma',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 22.67,
      tempiPercorso: 6,
      numPosti: 3,
      autista: {
        nome: 'Giancarlo',
        cognome: 'Amodio',
        recensione: 5,
        img: '../../../../assets/IMG/foto-profilo-test2.jpg'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia', 'Palermo', 'Salerno']
    },
    {
      id: 11,
      cittaPartenza: 'Roma',
      cittaArrivo: 'Milano',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 14.67,
      tempiPercorso: 5,
      numPosti: 5,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: null
    },
    {
      id: 10,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Milano',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 5,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: []
    },
    {
      id: 9,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 1,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 8,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 1,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 7,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Milano',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 32,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 6,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 4,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 5,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 9,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 4,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 6,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 3,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Roma',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 3,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 2,
      cittaPartenza: 'Milano',
      cittaArrivo: 'Roma',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 3,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: ['Roma', 'Milano', 'Brescia']
    },
    {
      id: 1,
      cittaPartenza: 'Napoli',
      cittaArrivo: 'Bologna',
      giorno: new Date().toLocaleString([], { year: "numeric", month: "2-digit", day: "2-digit" }),
      oraPartenza: '15:45',
      contributoEconomico: 34.67,
      tempiPercorso: 12,
      numPosti: 3,
      autista: {
        nome: 'lello',
        cognome: 'alfredini',
        recensione: 5,
        img: 'https://fastly.picsum.photos/id/91/3504/2336.jpg?hmac=tK6z7RReLgUlCuf4flDKeg57o6CUAbgklgLsGL0UowU'
      },
      tappeIntermedie: []
    },

  ];

  constructor(
    private fb: FormBuilder,
    private modalComponent: NewModalService,
    private confirmModal: NewConfirmModalService,
    private modalService: NgbModal,
    public hf: HookFunctions,
    private restService: TablesAgGridService
  ) {
    let ref = this;

    ref.setupAgSettings();
    // ref.setupAgServerSettings();
  }

  // AG-GRID-LOCALE

  setupAgSettings() {
    let ref = this;

    ref.gridOptions = {
      animateRows: true,
      pagination: true,
      paginationPageSize: 10,
      // localeText: AG_GRID_LOCALE_IT, //impostazioni lingua
      paginationPageSizeSelector: false, //per rimuovere la selezione degli elementi per pagina
      enableCellTextSelection: true, //per poter copiare il valore dal browser
      rowHeight: 50,
      defaultColDef: { //parametri di default per ogni colonna (gli stessi possono essere utilizzati singolarmente nei columnDefs)
        editable: false,
        filter: true, //viene visualizzata l'icona per inserire i filtri sulla colonna
        sortable: true, // permette l'ordinamento delle colonne
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center' },
        filterParams: {
          filterOptions: ['contains'], // per impostare le optioni di filtro di filtro
          suppressAndOrCondition: true // per non far visualizzare le condizioni AND e OR
          // buttons: ["apply", "reset"],
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },
      columnDefs: [
        {
          headerName: "#", //nome della colonna
          field: "id", //hiave di riferimento all'oggetto da far visualizzare
          valueFormatter: (params: any) => { // per customizzare il valore della cella
            return params.value ? params.value : "-";
          },
        },
        {
          headerName: "Partenza",
          field: "cittaPartenza",
          valueFormatter: (params: any) => {
            return params.value ? params.value : "-";
          },
        },
        {
          headerName: "Arrivo",
          field: "cittaArrivo",
          valueFormatter: (params: any) => {
            return params.value ? params.value : "-";
          },
        },
        {
          headerName: "Giorno",
          field: "giorno",
          valueFormatter: (params: any) => {
            return params.value ? params.value : "-";
          },
        },
        {
          headerName: "Prezzo",
          field: "contributoEconomico",
          valueFormatter: (params: any) => {
            return params.value ? params.value : "-";
          },
        },
        {
          headerName: "Actions",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi dettaglio viaggio',
                class: 'fas fa-eye btn btn-primary pointer me-2',
                action: (row: any) => {

                  ref.travelDetail = row;
                  ref.isOnlyForDetail = true;
                  ref.modalService.open(ref.theModalDetailTravel, { size: "xl" });
                }
              },
              /* {
                  label: "Effettua prenotazione",
                  class: 'fas fa-plus btn-first minPadding pointer',
                  action: (row: any) => {
                    ref.travelDetail = row;
                    ref.aggiungiViaggio(ref.travelDetail);
                  }
              } */
            ]
          }
        }
      ]
    }

  }


  // AG-GRID-SERVER
  setupAgServerSettings() {
    let ref = this;

    ref.gridServerOptions = {
      animateRows: true,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      // localeText: AG_GRID_LOCALE_IT, //impostazioni lingua
      paginationPageSizeSelector: false, //per rimuovere la selezione degli elementi per pagina
      enableCellTextSelection: true, //per poter copiare il valore dal browser
      rowHeight: 50,
      defaultColDef: { //parametri di default per ogni colonna (gli stessi possono essere utilizzati singolarmente nei columnDefs)
        editable: false,
        filter: true, //viene visualizzata l'icona per inserire i filtri sulla colonna
        sortable: true, // permette l'ordinamento delle colonne
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center' },
        filterParams: {
          filterOptions: ['contains'], // per impostare le optioni di filtro di filtro
          suppressAndOrCondition: true // per non far visualizzare le condizioni AND e OR
          // buttons: ["apply", "reset"],
        },
      },
      rowStyle: {
        background: ' #fff',
        color: '#000'
      },
      rowModelType: "infinite",
      columnDefs: [
        {
          headerName: "#",
          field: "importDetailBalancesAmountId",
          /* cellStyle: () => {
            return { display: "flex", alignItems: "center" };
          }, */
        },
        {
          headerName: "Conto",
          field: "conto",
          filter: 'agTextColumnFilter',
        },
        {
          headerName: "Progetto",
          field: "progetto",
          filter: 'agTextColumnFilter',
        },
        {
          headerName: "Anno",
          field: "esercizio",
        },
        {
          headerName: "Totale",
          field: "totale",
          valueFormatter: (params: any) => {
            return ref.hf.formatNumberInCurrencyString(parseFloat(params.value));
          },
        },
      ],
      datasource: {
        getRows: (params: any) => {
          try {
            let apiToCall = "";

            if (params.sortModel && params.sortModel.length == 0) {

              apiToCall = environment.apiEndpoint + `/UNISAGatewayRest/rest/variazionibudget/listAllImportDatiVariazioneBudget/300000008020964/*/C?pageNumber=${ref.actualPage}&pageMaxElement=10`;

            } else {

              let sort = params.sortModel[0];

              apiToCall = environment.apiEndpoint + `/UNISAGatewayRest/rest/variazionibudget/listAllImportDatiVariazioneBudget/300000008020964/*/C?typeFilter=${sort.colId}&orderFilter=${sort.sort.toUpperCase()}&pageNumber=${ref.actualPage}&pageMaxElement=10`;

            }

            if (params.filterModel && Object.values(params.filterModel).length > 0) {

              for (let key in params.filterModel) {
                console.log(params.filterModel[key]);
                apiToCall += `&${key}_like=${params.filterModel[key].filter}`
              }

            }

            ref.restService.getApiUrl(apiToCall).then(
              resp => {
                params.successCallback(
                  resp.importDetailBalancesAmountBindList,
                  resp.totalCount,
                );
              }
            )
            
          } catch (error) {
            console.error("errore datasource >>> ", error);
            params.successCallback([], 0,);
          }
        },
      },
    };
  }

  onPaginationChanged(event: any) {
    let ref = this;

    if (event.newPage) {
        ref.actualPage = event.api.paginationGetCurrentPage() + 1;
    }
  };
}
